import { Text } from '@fluentui/react'
import { PricingInfo, TokenRate } from '../../api/models'
import StatCard from '../common/StatCard'
import { formatCost, formatEstimatedCost } from './performanceFormat'

type CostTileProps = {
  cost: number | null
  pricing: PricingInfo
}

const COST_COLOR = '#5B8A72'
const NOTE_STYLES = { root: { color: '#605e5c' } }
const SECONDARY_NOTE_STYLES = { root: { color: '#797775' } }
const RATE_SOURCE_LABELS: Record<TokenRate['source'], string> = {
  default: '(default rate)',
  configured: '(configured)',
}

const describeRate = (rate: TokenRate, currency: string): string =>
  `${rate.model}: in ${formatCost(rate.input_per_million, currency)} / out ${formatCost(rate.output_per_million, currency)} per 1M tokens ${RATE_SOURCE_LABELS[rate.source]}`

const hasDistinctMatches = (rate: TokenRate): boolean =>
  rate.matched_models.length > 0 && !(rate.matched_models.length === 1 && rate.matched_models[0] === rate.model)

const RateLine = ({ rate, currency }: { rate: TokenRate; currency: string }) => (
  <>
    <Text variant="small" styles={NOTE_STYLES}>
      {describeRate(rate, currency)}
    </Text>
    {hasDistinctMatches(rate) && (
      <Text variant="xSmall" styles={SECONDARY_NOTE_STYLES}>
        Applies to: {rate.matched_models.join(', ')}
      </Text>
    )}
  </>
)

const CostTile = ({ cost, pricing }: CostTileProps) => (
  <StatCard title="Estimated cost" value={formatEstimatedCost(cost, pricing.currency, pricing.is_estimate)} color={COST_COLOR}>
    {pricing.is_estimate && (
      <Text variant="small" styles={NOTE_STYLES}>
        Approximate, based on list price per model
      </Text>
    )}
    {cost === null && pricing.unpriced_models.length > 0 && (
      <Text variant="small" styles={NOTE_STYLES}>
        Cost incomplete — no rate for: {pricing.unpriced_models.join(', ')}
      </Text>
    )}
    {pricing.rates.map((rate) => (
      <RateLine key={rate.model} rate={rate} currency={pricing.currency} />
    ))}
  </StatCard>
)

export default CostTile
